"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_hook_form_1 = require("react-hook-form");
var constants_1 = require("../constants");
var react_1 = require("react");
var utils_1 = require("../utils");
var classnames_1 = __importDefault(require("classnames"));
var close_svg_1 = __importDefault(require("../icons/close.svg"));
// import {faArrowDown, faFileImage, faFileAlt} from "@fortawesome/free-solid-svg-icons";
var FieldErrorMessage_1 = __importDefault(require("./FieldErrorMessage"));
var UploadButton = (0, react_1.forwardRef)(function (_a, ref) {
    var fileType = _a.fileType, text = _a.text, name = _a.name, rest = __rest(_a, ["fileType", "text", "name"]);
    var _b = (0, react_hook_form_1.useFormContext)(), control = _b.control, setValue = _b.setValue, resetField = _b.resetField, trigger = _b.trigger, _c = _b.formState, errors = _c.errors, submitCount = _c.submitCount;
    var _d = (0, react_1.useState)({
        value: "idle",
        message: "",
    }), status = _d[0], setStatus = _d[1];
    var _e = (0, react_1.useState)(null), savedFile = _e[0], setSavedFile = _e[1];
    var file = (0, react_hook_form_1.useWatch)({
        control: control,
        name: name,
    });
    (0, react_1.useEffect)(function () {
        trigger(name);
        if (!file) {
            setStatus({
                message: "",
                value: "idle",
            });
            setSavedFile(null);
        }
    }, [file]);
    (0, react_1.useEffect)(function () {
        var error = (0, utils_1.getError)(errors, name);
        if (error.value && submitCount > 0) {
            setStatus({
                value: error ? "error" : "success",
                message: (error === null || error === void 0 ? void 0 : error.message) || "",
            });
        }
    }, [errors, submitCount]);
    var textStatusColorMap = {
        success: "text-fi-primary",
        error: "text-fi-danger",
        idle: "text-fi-font",
    };
    var borderStatusColorMap = {
        success: "border-fi-primary",
        error: "border-fi-danger",
        idle: "border-fi-secondary",
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "min-w-full", children: [(0, jsx_runtime_1.jsx)("div", { className: "relative", children: (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: name, rules: {
                        required: (0, utils_1.isRequired)(name, rest.requiredFields),
                        validate: function (value) {
                            var result = (0, utils_1.validateFile)(value, name, rest.requiredFields, rest.max_upload_size, fileType, rest.allowedFileTypes);
                            if (value && value[0]) {
                                setSavedFile(value[0]);
                                if (typeof result === "string") {
                                    setStatus({
                                        value: "error",
                                        message: result,
                                    });
                                    setValue(name, value);
                                    return result;
                                }
                                if (value.length > 0) {
                                    setStatus({
                                        value: "success",
                                        message: "",
                                    });
                                }
                                else {
                                    setStatus({
                                        value: "idle",
                                        message: "",
                                    });
                                }
                            }
                            else {
                                setSavedFile(null);
                                setStatus({
                                    value: "idle",
                                    message: "",
                                });
                            }
                        },
                    }, render: function (_a) {
                        var field = _a.field;
                        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("label", { ref: field.ref, onDragOver: function (e) { return e.preventDefault(); }, onDrop: function (e) {
                                        e.preventDefault();
                                        field.onChange(e.dataTransfer.files);
                                    }, className: (0, classnames_1.default)("bg-white absolute inset-0 cursor-pointer z-[1] rounded-fi flex justify-center items-center border-dashed border-2 ", borderStatusColorMap[status.value]), htmlFor: !savedFile ? name : undefined, children: (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)("p-0 m-0", textStatusColorMap[status.value]), children: (0, jsx_runtime_1.jsxs)("div", { className: "flex bg-fi-bg-secondary rounded-fi items-center justify-center p-fi relative gap-spacing", onClick: function () {
                                                if (window.innerWidth < 768) {
                                                    resetField(name);
                                                }
                                            }, children: [(0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(savedFile === null || savedFile === void 0 ? void 0 : savedFile.name) && ((0, jsx_runtime_1.jsx)("div", { onClick: function () {
                                                                resetField(name);
                                                            }, className: "absolute -left-1 -top-1 bg-fi-danger rounded-full z-50 hover:scale-125", children: (0, jsx_runtime_1.jsx)(close_svg_1.default, { className: "w-[15px] h-[15px] p-[2px] text-fi-bg-secondary" }) })), status.value !== "idle" && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col", children: [status.value === "success" && ((0, jsx_runtime_1.jsx)("p", { className: "whitespace-nowrap text-ellipsis m-0 overflow-hidden max-w-[10rem] sm:max-w-fit", children: savedFile === null || savedFile === void 0 ? void 0 : savedFile.name })), status.value === "error" && ((0, jsx_runtime_1.jsx)(FieldErrorMessage_1.default, { errors: errors, name: name }))] }) }))] }), status.value === "idle" && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [text, " ", (0, utils_1.isRequired)(name, rest.requiredFields).value && "*"] }))] }) }) }), (0, jsx_runtime_1.jsx)("input", { id: name, onChange: function (e) {
                                        field.onChange(e.target.files);
                                    }, onBlur: function () {
                                        trigger(name);
                                    }, type: "file", accept: rest.allowedFileTypes
                                        ? (0, utils_1.getFormattedExtension)(rest.allowedFileTypes)
                                        : fileType === "photo"
                                            ? constants_1.IMAGE_FILES
                                            : constants_1.DOC_FILES, className: "p-fi-lg w-full bg-fi-secondary cursor-pointer rounded-fi", placeholder: (0, utils_1.t)("upload") })] }));
                    } }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col md:flex-row md:justify-between md:items-center mt-2", children: [rest.allowedFileTypes && ((0, jsx_runtime_1.jsxs)("small", { className: "text-sm font-light", children: [(0, utils_1.t)("allowed extensions"), ":", " ", (0, utils_1.getFormattedExtension)(rest.allowedFileTypes || constants_1.DOC_FILES)] })), (0, jsx_runtime_1.jsx)("br", {}), rest.max_upload_size && ((0, jsx_runtime_1.jsxs)("small", { className: "text-sm font-light", children: [(0, utils_1.t)("The maximum allowed size is"), ": ", (0, utils_1.toMB)(rest.max_upload_size)] }))] })] }));
});
exports.default = UploadButton;
